module.exports = __webpack_public_path__ + "img/btn-night-mode.cac74a47.svg";